module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch9",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "aria-label": "13",
      "id": "pg_13",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch9",
      "id": "ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("An Autumn Soul")])])])])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "VSB"
  }, [_vm._v("One day the leaves begin to change,")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("along with the love you thought you were in.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("You blink against your will, and feel your")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("heart begin to unravel …")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("shredding into pieces, as the person who you")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("deemed different begins to change along with")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("the season.")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("You mouth goodbye as he blends in")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("with hues of bad decisions,")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("jack-o-lantern masks,")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("and pumpkin-spiced kisses.")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("And you know how the leaves feel")]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_vm._v("as they fall, dying, onto the ground.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ec305564","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter9.vue
// module id = 96
// module chunks = 0